//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {},
  data: function data() {
    return {
      modal2: false,
      result: []
    };
  },
  mounted: function mounted() {},
  methods: {
    // 查询详情
    initOpen: function initOpen(result) {
      this.result = result || [];
      this.modal2 = true;
    }
  }
};